"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

var _NavItem = _interopRequireDefault(require("settings-ui-nav/utils/NavItem"));

var NavItemTitle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(NavItemTitle, _Component);

  function NavItemTitle() {
    (0, _classCallCheck2.default)(this, NavItemTitle);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NavItemTitle).apply(this, arguments));
  }

  (0, _createClass2.default)(NavItemTitle, [{
    key: "render",
    value: function render() {
      var navItem = this.props.navItem;
      return _react.default.createElement("span", null, _react.default.createElement("span", {
        className: "navItem"
      }, navItem.label), navItem.isBeta && _react.default.createElement(_UIBadge.default, {
        use: "beta",
        className: "m-left-2"
      }, _react.default.createElement(_FormattedReactMessage.default, {
        message: "settings-ui-nav.beta"
      })));
    }
  }]);
  return NavItemTitle;
}(_react.Component);

NavItemTitle.propTypes = {
  navItem: _propTypes.default.instanceOf(_NavItem.default).isRequired
};
var _default = NavItemTitle;
exports.default = _default;
module.exports = exports.default;